import { DrawerClose, DrawerFooter } from "@/components/ui/drawer";
import { Order, OrderType } from "@/models";
import { ethers } from "ethers";

interface CompleteOrderDrawerProps {
  order: Order;
  onClose: () => void;
  isLoading: boolean;
}

const CancelledOrderDrawer = ({ order, onClose }: CompleteOrderDrawerProps) => {
  return (
    <>
      <section className="mx-4 flex flex-col justify-center gap-2">
        <div className="flex flex-col justify-center gap-1">
          <label
            style={{
              fontWeight: "900",
            }}
            className={`font-satoshiBold w-fit rounded p-2 text-xs tracking-wide text-text-dark ${order.orderType === OrderType.BUY ? "bg-green-500" : "bg-yellow-500"}`}
            htmlFor="address">
            {order.orderType === OrderType.SELL ? "SEND" : "RECEIVE"}
          </label>
          <p className="text-2xl font-bold text-text-light">
            ₹ {ethers.utils.formatUnits(order.fiatAmount, 6)}
          </p>
        </div>
        {order.orderType === OrderType.BUY && (
          <div className="rounded border-[1px] border-red-500/30 bg-red-500/5 p-2">
            <p className="font-satoshiBold text-center text-[12px] tracking-wide text-red-500">
              The order was likely cancelled due to a failure in the payment
              through your UPI. If necessary, you can update your UPI ID.
            </p>
          </div>
        )}

        {order.orderType === OrderType.SELL && (
          <div className="rounded border-[1px] border-red-500/30 bg-red-500/5 p-2">
            <p className="font-satoshiBold text-center text-[12px] tracking-wide text-red-500">
              Order Cancelled Successfully.
            </p>
          </div>
        )}
      </section>
      <DrawerFooter>
        <DrawerClose
          onClick={() => {
            onClose?.();
          }}>
          <div className="w-full rounded-md border-[1px] border-black bg-bg-secondary p-2 font-bold text-text-light">
            Close
          </div>
        </DrawerClose>
      </DrawerFooter>
    </>
  );
};

export default CancelledOrderDrawer;
